// extracted by mini-css-extract-plugin
module.exports = {"header":"Onboarding_header__1gYmx","headerCatalog":"Onboarding_headerCatalog__2NJBZ","content":"Onboarding_content__3nzlZ","contentCatalog":"Onboarding_contentCatalog__21X6c"};